import React from "react";
import Query from "react-apollo/Query";
import { withRouter } from "react-router-dom";
import { withAuth } from "../../withAuth";
import { GET_CURRENT_STEAKING } from "../../../queries";

import TopPafeInfo from "../../Elements/BigElements/TopPageInfo/TopPafeInfo";
import InnerSteak from "../Steaking/InnerSteak";

class CurrentSteak extends React.Component {
    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            steakid: props.match.params.steakid
        };
    }
    
    render() {
        
        return (
            <div className="WithdrawalPage">                
                <TopPafeInfo session={this.props.session} />
                
                <div className="PersonalPageMain StandartPartMain">
                    <div className="PersonalPageMainPersonalInformation StandartBigElement">
                        <div class="IndexMainElementIn">
                            <div class="StandartElementTitle">STAKING $ARTY</div>
                            <div class="StandartElementTopBorder"></div>
                        </div>

                        <div className="MarketPageWithdrawalMoneyIn MarketPageWithdrawalMoneyIn02">

                            <Query query={GET_CURRENT_STEAKING} variables={{ steakid: this.state.steakid }}>
                                {({ data, loading, error }) => {
                                    if (loading) return <div>loading</div>;
                                    if (error) return <div>error</div>;

                                    console.log(data.getCurrentSteaking);

                                    return <InnerSteak Steak={data.getCurrentSteaking} session={this.props.session} TokenAmount={this.props.TokenAmount} refetch={this.props.refetch}/>
                                }
                                }
                            </Query>

                        </div>

                    </div>
                </div>
            </div>
            
        )
    }
}
export default withAuth(session => session && session.getCurrentUser)(withRouter(CurrentSteak));